// Bilingual UI strings (EN/ES)
export const STRINGS = {
  appName: { en: "FaithCycle", es: "FaithCycle" },
  tagline: {
    en: "Read scripture. Share light.",
    es: "Lee la escritura. Comparte la luz.",
  },
  signInGoogle: { en: "Continue with Google", es: "Continuar con Google" },
  signOut: { en: "Sign out", es: "Cerrar sesión" },
  nav: {
    home: { en: "Home", es: "Inicio" },
    read: { en: "Read", es: "Leer" },
    search: { en: "Search", es: "Buscar" },
    community: { en: "Community", es: "Comunidad" },
    groups: { en: "Groups", es: "Grupos" },
    plans: { en: "Plans", es: "Planes" },
    prayers: { en: "Prayers", es: "Oración" },
    studies: { en: "Studies", es: "Estudios" },
    bookmarks: { en: "Bookmarks", es: "Marcadores" },
    support: { en: "Support", es: "Apoyar" },
    profile: { en: "Profile", es: "Perfil" },
  },
  votd: { en: "Verse of the day", es: "Versículo del día" },
  continueReading: { en: "Continue reading", es: "Continuar leyendo" },
  version: { en: "Version", es: "Versión" },
  language: { en: "Language", es: "Idioma" },
  book: { en: "Book", es: "Libro" },
  chapter: { en: "Chapter", es: "Capítulo" },
  loading: { en: "Loading…", es: "Cargando…" },
  bookmark: { en: "Bookmark", es: "Guardar" },
  bookmarked: { en: "Saved", es: "Guardado" },
  share: { en: "Share reflection", es: "Compartir reflexión" },
  reflection: { en: "Reflection", es: "Reflexión" },
  reflectionPlaceholder: {
    en: "What is this verse teaching you today?",
    es: "¿Qué te enseña este versículo hoy?",
  },
  post: { en: "Post", es: "Publicar" },
  cancel: { en: "Cancel", es: "Cancelar" },
  reflectHere: { en: "Reflect on this verse", es: "Reflexionar sobre este versículo" },
  searchPlaceholder: {
    en: "Search words or phrases…",
    es: "Buscar palabras o frases…",
  },
  searchHint: { en: "Type at least 3 characters", es: "Escribe al menos 3 caracteres" },
  noResults: { en: "No results found", es: "Sin resultados" },
  communityFeed: { en: "Community feed", es: "Feed de la comunidad" },
  newestFirst: { en: "Latest reflections", es: "Últimas reflexiones" },
  emptyFeed: {
    en: "No reflections yet. Be the first to share.",
    es: "Aún no hay reflexiones. Sé el primero.",
  },
  likes: { en: "likes", es: "me gusta" },
  comments: { en: "comments", es: "comentarios" },
  addComment: { en: "Add a comment…", es: "Añadir un comentario…" },
  send: { en: "Send", es: "Enviar" },
  browseGroups: { en: "Study groups", es: "Grupos de estudio" },
  createGroup: { en: "Create group", es: "Crear grupo" },
  groupName: { en: "Group name", es: "Nombre del grupo" },
  groupDesc: { en: "Description", es: "Descripción" },
  join: { en: "Join", es: "Unirse" },
  leave: { en: "Leave", es: "Salir" },
  members: { en: "members", es: "miembros" },
  yourReadingPlans: { en: "Reading plans", es: "Planes de lectura" },
  startPlan: { en: "Start plan", es: "Comenzar plan" },
  days: { en: "days", es: "días" },
  day: { en: "Day", es: "Día" },
  read: { en: "Read", es: "Leer" },
  markDone: { en: "Mark as done", es: "Marcar como leído" },
  markUndone: { en: "Undo", es: "Deshacer" },
  progress: { en: "Progress", es: "Progreso" },
  bookmarksTitle: { en: "Your bookmarks", es: "Tus marcadores" },
  noBookmarks: {
    en: "No bookmarks yet. Save a verse from the reader.",
    es: "Aún no hay marcadores. Guarda un versículo desde la lectura.",
  },
  profile: { en: "Profile", es: "Perfil" },
  email: { en: "Email", es: "Correo" },
  memberSince: { en: "Member since", es: "Miembro desde" },
  landingH1: {
    en: "Grow in God's Word. Pray. Share your testimony.",
    es: "Crece en la Palabra. Ora. Comparte tu testimonio.",
  },
  landingSub: {
    en: "A place to grow in God's Word, pray for others and share your testimony of God's greatness. Bilingual Bible in KJV, WEB, RV 1960, Reina Valera Gómez and NTV — with a thoughtful community.",
    es: "Un lugar para crecer en la Palabra de Dios, orar por otros y compartir tu testimonio de las grandezas de Dios. Biblia bilingüe en KJV, WEB, RV 1960, Reina Valera Gómez y NTV — con una comunidad pausada.",
  },
  ot: { en: "Old Testament", es: "Antiguo Testamento" },
  nt: { en: "New Testament", es: "Nuevo Testamento" },
  postedIn: { en: "in", es: "en" },
  general: { en: "General feed", es: "Feed general" },
  reflectingOn: { en: "Reflecting on", es: "Reflexionando en" },
};

export const t = (key, lang) => {
  const parts = key.split(".");
  let obj = STRINGS;
  for (const p of parts) obj = obj?.[p];
  if (!obj) return key;
  return obj[lang] || obj.en || key;
};
